import script from "./PlatformOfferCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformOfferCard.vue?vue&type=script&setup=true&lang=js"

import "./PlatformOfferCard.vue?vue&type=style&index=0&id=4acb5b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acb5b72"]])

export default __exports__